//Dependencies & helpers
import React from "react";
import ReactDOM from "react-dom";
//Main view
import App from "./App";
//Styles
import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
